import {BaseWrapper} from '../../framework/parameters/BaseWrapper';
import {BasicScenario} from '../../framework/parameters/BasicScenario';
import {Role} from '../message/Role';
import {RoleCriteria} from './RoleCriteria';

export class RoleWrapper extends BaseWrapper<Role, RoleCriteria, BasicScenario>  {}

